// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Meal           = require("../model/Meal");
var Block          = require("bs-platform/lib/js/block.js");
var Curry          = require("bs-platform/lib/js/curry.js");
var React          = require("react");
var Router         = require("../ffi/Router");
var Category       = require("../model/Category");
var ReasonReact    = require("reason-react/lib/js/src/ReasonReact.js");
var AddMealScreen  = require("./AddMealScreen");
var OverviewScreen = require("./OverviewScreen");

var component = ReasonReact.reducerComponent("DashboardScreen");

function urlToRoute(url) {
  var match = url[/* path */0];
  if (match) {
    if (match[0] === "add") {
      return /* AddMeal */1;
    } else {
      return /* NotFound */3;
    }
  } else {
    return /* Overview */0;
  }
}

function make(user, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      Category.getCategories(user.uid).then((function (categories) {
              Curry._1(self[/* send */4], /* UpdateCategories */Block.__(2, [categories]));
              return Meal.getMeals(user.uid, categories).then((function (meals) {
                            return Promise.resolve(Curry._1(self[/* send */4], /* UpdateMeals */Block.__(1, [meals])));
                          }));
            }));
      var init = self[/* state */2];
      return /* Update */Block.__(0, [/* record */[
                  /* route : Some */[urlToRoute(Router.getUrl(/* () */0))],
                  /* quickAdd */init[/* quickAdd */1],
                  /* meals */init[/* meals */2],
                  /* categories */init[/* categories */3]
                ]]);
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* route */0];
      if (match) {
        switch (match[0]) {
          case 0 : 
              return ReasonReact.element(/* None */0, /* None */0, OverviewScreen.make(self[/* state */2][/* meals */2], (function (meal) {
                                Curry._1(self[/* send */4], /* QuickAdd */Block.__(0, [meal]));
                                return ReasonReact.Router[/* push */0]("/add");
                              }), /* array */[]));
          case 1 : 
              return ReasonReact.element(/* None */0, /* None */0, AddMealScreen.make(self[/* state */2][/* quickAdd */1], /* array */[]));
          case 2 : 
              return React.createElement("div", undefined);
          case 3 : 
              return React.createElement("div", undefined, "Not Found");
          
        }
      } else {
        return null;
      }
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* route : None */0,
              /* quickAdd : None */0,
              /* meals : [] */0,
              /* categories : [] */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      switch (action.tag | 0) {
        case 0 : 
            return /* Update */Block.__(0, [/* record */[
                        /* route */state[/* route */0],
                        /* quickAdd : Some */[action[0]],
                        /* meals */state[/* meals */2],
                        /* categories */state[/* categories */3]
                      ]]);
        case 1 : 
            return /* Update */Block.__(0, [/* record */[
                        /* route */state[/* route */0],
                        /* quickAdd */state[/* quickAdd */1],
                        /* meals */action[0],
                        /* categories */state[/* categories */3]
                      ]]);
        case 2 : 
            return /* Update */Block.__(0, [/* record */[
                        /* route */state[/* route */0],
                        /* quickAdd */state[/* quickAdd */1],
                        /* meals */state[/* meals */2],
                        /* categories */action[0]
                      ]]);
        case 3 : 
            return /* Update */Block.__(0, [/* record */[
                        /* route : Some */[action[0]],
                        /* quickAdd */state[/* quickAdd */1],
                        /* meals */state[/* meals */2],
                        /* categories */state[/* categories */3]
                      ]]);
        
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return Router.watchUrl((function (url) {
                                  return Curry._1(self[/* send */4], /* ChangeRoute */Block.__(3, [urlToRoute(url)]));
                                }));
                  }),
                Router.unwatchUrl
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.component  = component;
exports.urlToRoute = urlToRoute;
exports.make       = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/screen/DashboardScreen.re
// module id = 262
// module chunks = 0